// extracted by mini-css-extract-plugin
export default {"sessionDetailsEntry":"SessionDetailsEntry_sessionDetailsEntry__KcwIV","footer":"SessionDetailsEntry_footer__Yf5MU","cancel":"SessionDetailsEntry_cancel__k5Tnc"};